import gql from 'graphql-tag';

export default {
    profile: gql`
        fragment ProfileFragment on Profile {
            id
            url
            name
            shareURL
            image {
                ...ImageFragment
            }
            whiteLabelImage {
                ...ImageFragment
            }
            customFaviconImage {
                ...ImageFragment
            }
            brandColor
            brandLink
            language
            defaultPrivacyText
            defaultTermsText
            defaultTermsAndConditionsConsentText
            defaultPrivacyPolicyConsentText
            boostWords
        }
    `,
    image: gql`
        fragment ImageFragment on Image {
            urlTemplate
            color
        }
    `,
    audio: gql`
        fragment AudioFragment on Audio {
            url
            __typename
        }
    `,
    post: gql`
        fragment PostFragment on Post {
            id
            url
            shareURL
            image {
                ...ImageFragment
            }
            audio {
                ...AudioFragment
            }
            caption
            profile {
                ...ProfileFragment
            }
            timestampCreated
            timestampUserModified
            shareVideoWithTranscriptURL
            rawTranscript
            rawTranscriptProofRead
            rawTranscriptTranslated
            transcriptLanguage
            link {
                url
                title
                imageURL
            }
            shopifyProductID
            status
            contributorName
        }
    `,
    postWithSensitiveData: gql`
        fragment PostWithSensitiveDataFragment on PostWithSensitiveData {
            id
            url
            shareURL
            image {
                ...ImageFragment
            }
            audio {
                ...AudioFragment
            }
            caption
            timestampCreated
            timestampUserModified
            shareVideoWithTranscriptURL
            rawTranscript
            rawTranscriptProofRead
            rawTranscriptTranslated
            transcriptLanguage
            link {
                url
                title
                imageURL
            }
            shopifyProductID
            status
            externalID
            contributorEmail
            contributorName
            bookmarked
            summaryParagraph
            summaryHeadline
            aiMetrics
            rating
        }
    `,

    postWithSensitiveDataFullTranscripts: gql`
        fragment PostWithSensitiveDataFullTranscriptsFragment on PostWithSensitiveData {
            transcript {
                words {
                    content
                    timeStart
                    timeEnd
                }
            }
        }
    `,

    postFullTranscripts: gql`
        fragment PostFullTranscripts on Post {
            transcript {
                words {
                    content
                    timeStart
                    timeEnd
                }
            }
        }
    `,
    campaign: gql`
        fragment CampaignFragment on Campaign {
            id
            status
            name
            boostWords
            promptText
            timestampCreated
            timestampActivated
            timestampDeactivated
            timestampModified
            termsText
            privacyText
            successText
            successLink
            successLinkLabel
            successShareEnabled
            contributionURL
            enforcesTermsAndConditionsConsent
            enforcesPrivacyPolicyConsent
            numberOfVoices
            hideBeamsBranding
            color
            backgroundColor
            image {
                ...ImageFragment
            }
            backgroundImage {
                ...ImageFragment
            }
            responsesMetaSummary
            aiMetrics
            maximumRecordingDuration
            termsAndConditionsConsentText
            privacyPolicyConsentText
            isNPSCampaign
            NPSQuestion
            promptSublineText
            recordButtonLabel
            isCSATCampaign
            CSATQuestion
            interfaceLanguage
            enabledWidgets
            widgetConfigs
            collectNames
            collectEmails
            collectImages
            videoURLs
            conversationalSurvey
            newRecorder
            agentWelcomeMessage
            textFieldDefault
            tags {
                ...TagFragment
            }
            autoDetectsSpeechLanguage
        }
    `,
    campaignContribution: gql`
        fragment CampaignContributionFragment on CampaignContributionResponse {
            id
            promptText
            termsText
            privacyText
            successText
            successLink
            successLinkLabel
            successShareEnabled
            enforcesConsent
            contributionURL
            status
            color
            backgroundColor
            image {
                ...ImageFragment
            }
            profile {
                ...ProfileFragment
            }
            canAcceptResponses
            maximumRecordingDuration
            consentText
            isNPSCampaign
            NPSQuestion
            promptSublineText
            recordButtonLabel
            isCSATCampaign
            CSATQuestion
            interfaceLanguage
            enabledWidgets
            collectNames
            collectEmails
            collectImages
            videoURLs
            conversationalSurvey
            newRecorder
            agentWelcomeMessage
            textFieldDefault
        }
    `,

    cluster: gql`
        fragment ClusterFragment on Cluster {
            id
            name
            sentiment
            mentionsCount
            ids
            classes {
                ...ClusterClassFragment
            }
        }
    `,

    clusterClass: gql`
        fragment ClusterClassFragment on ClusterClass {
            name
            sentiment
        }
    `,

    clusterSet: gql`
        fragment ClusterSetFragment on ClusterSet {
            classTypeID
            classTypeName
            clusters {
                ...ClusterFragment
            }
        }
    `,

    identifiedClass: gql`
        fragment IdentifiedClassFragment on IdentifiedClass {
            class
            similarity
        }
    `,

    identifiedClasses: gql`
        fragment IdentifiedClassesFragment on IdentifiedClasses {
            postID
            classes {
                ...IdentifiedClassFragment
            }
        }
    `,

    tag: gql`
        fragment TagFragment on Tag {
            id
            name
            color
        }
    `,
};
